import { exportReportPackage } from "@api/accountingReports.api";
import { AccountingReportType } from "@common/types/reports/report-type";
import { ReportPackageReportSetting } from "@common/types/reports/report-package";
import { saveBlobResponse, useFileDownload } from "@lib/fileDownload";

export function useReportPackageDownload(
    params: {
        entityIds: number[];
        reportTypes: AccountingReportType[];
        startDate: string;
        endDate: string;
        ledgerId: string;
        reportSettings?: Partial<
            Record<AccountingReportType, ReportPackageReportSetting>
        >;
    } | null,
) {
    return useFileDownload(async () => {
        if (!params) {
            return;
        }

        const response = await exportReportPackage(params);

        if (!response) {
            return;
        }

        saveBlobResponse(response, "Report Package");
    });
}
